import React, { memo } from 'react';

import Wrapper from './styles';

const ContentPlaceholder = memo((props) => <Wrapper {...props} />);

export default ContentPlaceholder;
